export type ISaveFormForLater = (button: IjQueryElmOrHtmlElm, form?: HTMLFormElement) => void;

export function saveFormForLater(button: IjQueryElmOrHtmlElm, form?: HTMLFormElement): void {
  const $button = $(button);
  const $form = form ? $(form) : $button.closest('form');

  if ($button.hasClass('btn')) {
    window.DexeroCoreApp.animateButton($button as IjQueryElm);
  }
  ($form as any).find(':input[name="direction"]').val('saveForLater');

  ($form[0] as HTMLFormElement).submit();
}
